module.exports = __webpack_public_path__ + "img/border_Ellipse.7625ca47.svg";